<p-card>

    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12 breadcrumbrightmenu">
        <button pTooltip="Help" tooltipPosition="left" aria-hidden="true" class="fa fa-question helpicon"
        (click)="helpservice.openhelpmodal(ref, dialogService, 'Help', 20)">
        </button>
      </div> 
    </div> 
      <p style="font-size:.8 rem; font-weight:bolder; color:crimson">
        You need to select one organisation for which you require the Client Usage Report. Choose From and To Date, if required.
        The processed data will be displayed on the screen. If required, you can take an excel dump. 
        If so,  an Excel file will be generated that will contain the Client Usage Data. Please check your Download folder after the program completes execution.
      </p>
</p-card>

    
    <div class="grid mt-1">
      <div class="col-4">
        <label for="orgid" class="required-label">Organisation<span>&nbsp;*</span></label>
        <p-dropdown 
        [(ngModel)]="selectedorgid"
        (onChange)="orgidchange($event)"
        [options]="orgs" 
        optionLabel="name"
        optionValue="orgid" 
        styleClass="fixed-width-dropdown-filter" 
        inputId="orgid" 
        placeholder="Select"
        [filter]="true" 
        appendTo="body" 
        [resetFilterOnHide]="true" 
        [showClear]="true">
        </p-dropdown>
      </div>
      
      
      <div class="col-2">
        <label for="fromDate" class="required-label">From Date<span>&nbsp;*</span></label><br/>

        <p-calendar 
        [showIcon]="true" 
        [(ngModel)]="fromDate" 
        placeholder="Choose Date"
        dateFormat="dd-M-yy" 
        (onSelect)="validateDates()"
        (onClear)="onClear()"
        inputId="fromDate" 
        [showButtonBar]="true" 
        todayButtonLabel="Today" 
        styleClass="pcalendar-readonly" 
        [showOtherMonths]="true" 
        [selectOtherMonths]="true"
        >
        </p-calendar><br/>
      </div>
        
      <div class="col-2">
        <label for="toDate" class="required-label">To Date<span>&nbsp;*</span></label><br/>
        <p-calendar 
        [showIcon]="true" 
        [(ngModel)]="toDate" 
        placeholder="Choose Date"
        dateFormat="dd-M-yy" 
        (onSelect)="validateDates()"
        (onClear)="onClear()"
        inputId="toDate" 
        [showButtonBar]="true"
        todayButtonLabel="Today" 
        styleClass="pcalendar-readonly" 
        [showOtherMonths]="true" 
        [selectOtherMonths]="true"   
        >
        </p-calendar><br/>
        <div class="validation-space">
          <span *ngIf="errorDIsplay" style="color: red;">From Date can't be greater than To Date</span>
        </div>
      </div>
      <div class="col-1 mt-4">
      <p-button class="green-button" pTooltip="Reset" tooltipPosition="bottom" severity="success" (click)="refreshData()" >
               <i class="fa fa-refresh" aria-hidden="true"></i>
        </p-button>
      </div>
      <div class="col-1 mt-4">
        <p-button label="Generate" styleClass="reset-btn" pTooltip="Generate" (click)="getcompanydata()"
          tooltipPosition="right"></p-button>
      </div>
      <div class="col-1 mt-4">
         <div class="iconexcel" pTooltip="Download Data" tooltipPosition="bottom"
             (click)="generateExcel();"></div>
        </div>
    <div class="col-1 mt-4">
    <div class="iconexcel" pTooltip="Download Data for all Organisations" tooltipPosition="bottom"
      (click)="generateallExcel();"></div>
  </div>
        
</div>

    <div class="mr-0">
      <p-table  
      #dt 
      [value]="datalist" 
      [scrollable]="true" 
      scrollDirection="horizontal" 
      dataKey="id" 
      [rowHover]="true" 
      responsiveLayout="scroll" 
      >
  

        <ng-template pTemplate="header">
          <tr>
            <th>Org / Entity&nbsp;&nbsp;</th>
            <th>Go live Date&nbsp;&nbsp;</th>
            <th>Org Type&nbsp;&nbsp;</th>
            <th>Storage (GB)&nbsp;&nbsp;</th>
            <th>NC&nbsp;&nbsp;</th>
            <th>LC&nbsp;&nbsp;</th>
            <th>OT&nbsp;&nbsp;</th>
            <th>NA&nbsp;&nbsp;</th>
            <th>PA&nbsp;&nbsp;</th>
            <th>Due&nbsp;&nbsp;</th>
            <th>Total&nbsp;&nbsp;</th>
            <th>Action %&nbsp;&nbsp;</th>
            <th>IC&nbsp;&nbsp;</th>
            <th>Tasks&nbsp;&nbsp;</th>
            <th>Contract&nbsp;&nbsp;</th>
            <th>Registration&nbsp;&nbsp;</th>
            <th>Litigation&nbsp;&nbsp;</th>
            <th>Notice&nbsp;&nbsp;</th>
            <th>Insurance&nbsp;&nbsp;</th>
            <th>Assessment&nbsp;&nbsp;</th>
            <th>Audit&nbsp;&nbsp;</th>
            <th>Audit Findings&nbsp;&nbsp;</th>
            <th>HD Customer&nbsp;&nbsp;</th>
            <th>HD Complinity&nbsp;&nbsp;</th>
            <th>Attach HD&nbsp;&nbsp;</th>
            <th>Attach Except HD&nbsp;&nbsp;</th>

          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-data>
          <tr  style="vertical-align: top;">
            <td>{{data["name"] }}</td>
            <td>{{data["golivedate"] }}</td>
            <td>{{data["orgtype"] }}</td>
            <td>{{data["orgfilesize"] }}</td>
            <td>{{data["orgcinc"] }}</td>
            <td>{{data["orgcilc"] }}</td>
            <td>{{data["orgciot"] }}</td>
            <td>{{data["orgcina"] }}</td>
            <td>{{data["orgcipa"] }}</td>
            <td>0</td>
            <td>{{ (data.tot) }}</td>
            <td>{{ (data.aper) }}</td>
            <td>{{ (data.orgciic) }}</td>
            <td>{{data["orgtask"] }}</td>
            <td>{{data["orgcontract"] }}</td>
            <td>{{data["orgregistration"] }}</td>
            <td>{{data["orgcase"] }}</td>
            <td>{{data["orgnotice"] }}</td>
            <td>{{data["orginsurance"] }}</td>
            <td>{{data["orgassess"] }}</td>
            <td>{{data["orgaudit"] }}</td>
            <td>{{data["orgauditfinding"] }}</td>
            <td>{{data["orghdslc"] }}</td>
            <td>{{data["orghdothers"] }}</td>
            <td>{{data["orgcompattachhd"] }}</td>
            <td>{{data["orgattachmain"] }}</td>
         </tr>
        </ng-template>
      </p-table>
    </div>  

    
